import { createStore } from 'vuex'

export default createStore({
  state: {
    videoUrlNow: '',
    // 添加一个全局的 flag 状态
    isFlagVisible: true // 默认隐藏
  },
  getters: {
    // 可以添加一个 getter 来方便访问
    getFlagVisibility: (state) => state.isFlagVisible
  },
  mutations: {
    // 添加 mutation 来修改 flag
    SET_FLAG_VISIBILITY(state, visibility) {
      state.isFlagVisible = visibility
    }
  },
  actions: {
    // 可以添加 action 来提交 mutation（可选）
    setFlagVisibility({ commit }, visibility) {
      commit('SET_FLAG_VISIBILITY', visibility)
    }
  },
  modules: {
  }
})